//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Builder.js";
let d=[[[0,"UdfType",1,0]],[[["descriptionContents"],"SetDescriptionContents",{},1,0],[["nDescriptionContents"],"GetDescriptionContents",{R_:{descriptionContents:""}},0,0],[["descriptionContents"],"SetCommandName",{},1,0],[[],"GetCommandName",{R_:{descriptionContents:''}},0,0]],[]];
SPLM.Motion.UdfDescriptionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.UdfDescriptionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.UdfDescriptionBuilder.UdfNumber = Object.freeze({
    "None" : "None", "Udf1" : "Udf1", "Udf2" : "Udf2", "Udf3" : "Udf3", "Udf4" : "Udf4", "Udf5" : "Udf5", "Udf6" : "Udf6", "Udf7" : "Udf7", "Udf8" : "Udf8", "Udf9" : "Udf9", "Udf10" : "Udf10"});

export default SPLM;